import { useEffect, useState, useCallback, useMemo, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { PivotItem } from "@fluentui/react";
import _ from "lodash";
import UserProfile from "./UserProfile";
import userOperations from "../../../redux/UserProfile/operations";
import { setResultMessage } from "../../../redux/UserProfile/actions";
import userSelectors from "../../../redux/UserProfile/selectors";
import { CustomTreeview, EventHandler, PrimaryButton, ReactSelectBox } from "../../CommonComponents";
import uploadimg from "../../assets/images/Upload.svg";
import resetIcon from '../../assets/images/Reset.svg'
import notificationServices from "client/services/notification.service";
import { AN_TYPES, isEmail } from "utils";
import SuccessBee from "../../assets/images/SuccessBee.svg";
import { UploadUserProfileImage,saveUserProfileBranches, saveUserProfileNotificationSubs, saveUserProfilePersonalInfo,setUserProfileImage } from "Store/Identity/UserProfiles/UserProfileAction";
import { CONSTANTS } from "client/utils/constants";
import ConfirmationBee from '../../assets/images/ConfirmationBee.svg'
import { setCurrentSettingsProfile, setIsOutOfOfficeSavedProfile } from "Store/OrderManagement/OutOfOffice/OutOfOfficeActions";

let count = 1

const UserProfileContainer = ({ closeModalPopup }: any) => {
  const dispatch = useDispatch();
  const [userName, setUserName] = useState({
    firstName: "",
    lastName: "",
    preferredName: "",
    userEmail: "",
    employeeNumber: "",
    title: "",
    homeCostCenter: "",
  });
  const dispatchGetCountryDropdown =
    userOperations.dispatchGetCountryDropdown(dispatch);
  const dispatchGetUserDetailsExternal =
    userOperations.dispatchGetUserDetailsExternal(dispatch);
  const dispatchGetUserDetails = userOperations.dispatchGetUserDetail(dispatch);  

  const { countryDropdown, externalUserData } = useSelector((state) => ({
    countryDropdown: userSelectors.countryDropdown(state),
    externalUserData: userSelectors.externalUserData(state),
  }));

  const { 
    userDetails, 
    resultMessage,
    isOutOfOfficeSavedProfile,
      userProfileImage,
      defaultBranchDetails
  }: any = useSelector((state: any) => ({
    userDetails: userSelectors.getUserDetails(state),
    resultMessage: userSelectors.getResultMessage(state),
    isOutOfOfficeSavedProfile: state?.OutOfOfficeReducer?.isOutOfOfficeSavedProfile,
    userProfileImage: state.UserProfileReducer.userProfileImage,
    defaultBranchDetails: state.GetBranchDetails.BranchDetails
  }));

  const [form, setForm] = useState<any>({
    preferredName: userDetails?.userName,
    emailId: "",
    personalEmailId: "",
    contactNo: "",
    addressLine1: "",
    addressLine2: "",
    city: "",
    state: "",
    roleId: null,
    countryId: null,
    zipCode: "",
    profileBlobUrl: "",
    files: [],
    branchIds: [],
    id: "",
  });
  const [selectedTab, setSelectedTab] = useState<any>("Personal Info");
  const [costCenterOptions, setCostCenterOptions] = useState<any>([])
  const [ filteredCostCenter, setFilteredCostCenter] = useState<any>('')
  const [expanded, setExpanded] = useState<any>(['Locations'])
  const [Popupcontent, setPopupcontent] = useState<any>({
    title: "",
    isDialogVisible: false,
    isTitleWarning: false,
    subtextcontent: "",
    primaryBtnText: "",
    outlineBtnText: "",
    isSingleConfirmationBtn: false,
    isCommentboxVisible: false,
    isCompletedReportVisible: false,
    titleImg: "",
    isCommentBoxRequire: false,
    outlineBtnnavigateTo: "",
    primaryBtnnavigateTo: "",
    actionby: "",
    value: 0,
    comments: "",
    popupOutlinebtnOnclick: () => { },
    popupPrimarybtnOnclick: () => { }
  });

  useEffect(() => {
    if (userDetails?.userId) {
      dispatchGetCountryDropdown()
    }
  }, [userDetails?.userId]);

  const [userprofileinfo, setuserprofileinfo] = useState<any>({
    imagename: "",
    imguploaded: false,
    profileImageError: "",
  });
  useEffect(() => {
    if (countryDropdown) {
      countryDropdown?.forEach((x: any, i: any) => {
        x["key"] = x.value;
      });
    }
  }, [countryDropdown]);
  const getbranches = userOperations.dispatchBrahchValues(dispatch);
  const { getBranchValues } = useSelector((state) => ({
    getBranchValues: userSelectors.getBranchValues(state),
  }));
  useEffect(() => {
    if(selectedTab === 'Locations' && getBranchValues?.length === 0){
      getbranches();
    }
  }, [selectedTab]);

  useEffect(() => {
    if (userDetails?.emailId) {
      dispatchGetUserDetailsExternal(userDetails?.emailId);
    }
  }, [userDetails]);

  useEffect(() => {
    if(userProfileImage !== "" && userProfileImage !== undefined) {
      setForm({ ...form, profileBlobUrl: userProfileImage[0] });
      setuserprofileinfo({...userprofileinfo, imguploaded: true})
    } else if(userProfileImage !== undefined){
      setForm({ ...form, profileBlobUrl: "" });
      setuserprofileinfo({...userprofileinfo, imguploaded: false, profileImageError: "Error uploading image. Please try again."})
    }
    dispatch(setUserProfileImage(undefined))
  }, [userProfileImage])

  const branchcheck = userDetails?.branches?.map((i: any) => i.branchNo);

  let [strcount, setCount] = useState<any>(0);

  const [checkedValue, setChecked] = useState<any>([...branchcheck]);
  let Item = useRef<any>([...branchcheck])

  const OnCheckboxClick = (item: any) => {
    Item.current = item
    setChecked(item);
    setCount(1)
    let arr = item.map((x: any) => parseInt(x))?.filter((x: any) => x);
    setForm({ ...form, branchIds: arr });
  };
  const initialError = {
    employeeIdError: "",
    titleIdError: "",
    departmentIdError: "",
    branchError: "",
    zipCodeError: "",
    personalEmailId: "",
    contactNoError: "",
    profileImageError: "",
  };
  const [formError, setFormError] = useState<any>(initialError);
  const [selectedCountry, setSelectedCountry] = useState<any>("");
  const [uploadedImage, setUploadedImage] = useState<string>("");
  const errorMessage = "Please resolve error before saving";

  const onChangeProfile = (e: any) => {
    const imgsrc = URL.createObjectURL(e.target.files[0]);
    if (e.target.files[0]) {
      const filesize = Math.round(e.target.files[0].size * 0.001 * 100) / 100;
      let imagename = "Upload Your Profile";
      if (filesize < 150) {
        imagename = e.target.files[0].name;
        setForm({ ...form, profileBlobUrl: imgsrc });
        setUploadedImage(imgsrc);

        let reader = new FileReader();
        reader.readAsDataURL(e.target.files[0]);
        reader.onload = (event: any) => {
          const image: any = new Image();
          image.src = event.target.result;
          image.onload = function () {
            const height = this.height;
            const width = this.width;
            if (height > 400 || width > 400) {
              setForm({ ...form, profileBlobUrl: null });
              setUploadedImage(uploadimg);
              setuserprofileinfo({
                ...userprofileinfo,
                imagename: imagename,
                profileImageError:
                  "Profile image's height and width must not exceed 400px.",
              });
              let errorValue = validation("profileImageDimension", height);
              setFormError({ ...errorValue });
              return false;
            }
          };
          setForm({
            ...form,
            files: e.target.files[0],
          });
        };
        let formData = new FormData()
        formData.append('Files', e.target.files[0])
        formData.append('UserEmail', userDetails?.emailId)
        dispatch(UploadUserProfileImage(formData));
        setuserprofileinfo({
          ...userprofileinfo,
          imagename: imagename,
          profileImageError: "",
        });
      } else {
        setForm({ ...form, profileBlobUrl: null });
        setUploadedImage(uploadimg);
        setuserprofileinfo({
          ...userprofileinfo,
          imagename: imagename,
          profileImageError: "Profile image shoule be less than 150kb",
        });
        let errorValue = validation("profileImage", filesize);
        setFormError({ ...errorValue });
      }
    }
  };

  const onChangeCountry = (event?: any, item?: any): void => {
    setSelectedCountry(item);
    const value = item.value;
    const name = event.target.getAttribute("name");
    setForm({ ...form, [name]: value });
  };

  const [subscriptions, setSubscriptions] = useState([]);
  const [lookups, setLookups] = useState([]);
  const [messageTypes, setMessageTypes] = useState([]);
  const [allValues, setAllValues] = useState([]);
  const [subscriptionTypes, setSubscriptionTypes] = useState([]);

  const getSubscriptionTypes = async () => {
    const res = await notificationServices.getSubscriptionTypes();
    setSubscriptionTypes(res || []);
  };

  const getLookups = async () => {
    const res = await notificationServices.getLookups();
    setLookups(res || []);
  };

  const getMessageTypes = async () => {
    const res = await notificationServices.getMessageTypes();
    setMessageTypes(res || []);
  };

  const getNotificationSubscription = async () => {
    const res = await notificationServices.getNotificationSubscription(
      userDetails.userId
    );
    setSubscriptions(res || []);
  };

  // Fetching all required data
  useEffect(() => {
    getLookups();
    getMessageTypes();
    getSubscriptionTypes();
  }, []);

  // Creating object for saving -> from master data
  useEffect(() => {
    if (lookups.length && messageTypes.length && subscriptionTypes.length) {
      const arr: any = [];
      const subscriptionTypeId: any = (
        subscriptionTypes.find((x: any) => x.value === "User") as any
      )?.subscriptionTypeId;

      lookups?.forEach((lookup: any) => {
        messageTypes?.forEach((messageType: any) => {
          const obj = {
            senderId: userDetails?.userId,
            lookupid: lookup?.lookupId,
            lookup: lookup?.notificationDeliveryTypeValue,
            notificationMessageTypeId: messageType?.notificationMessageTypeId,
            notificationMessageType: messageType?.messageType,
            subscriptionTypeId,
            isActive: !!subscriptions.find(
              (y: any) =>
                y.lookupId === lookup?.lookupId &&
                y.notificationMessageTypeId ===
                messageType?.notificationMessageTypeId
            ),
            savedBy: userDetails?.emailId,
          };
          arr.push(obj);
        });
      });

      setAllValues(arr);
    }
  }, [
    lookups,
    messageTypes,
    subscriptions,
    userDetails?.userId,
    subscriptionTypes,
  ]);

  useEffect(() => {
    if (userDetails.userId) {
      getNotificationSubscription();
    }
  }, [userDetails.id]);

  const handleChange =
    (lookup: any, messageType: any) => (_: any, checked: boolean) => {
      setAllValues((prev: any) => {
        return prev.map((x: any) => {
          if (
            x.lookupid === lookup &&
            x.notificationMessageTypeId === messageType
          ) {
            return { ...x, isActive: checked };
          }

          return x;
        });
      });
    };

  const notificationConfiguration = useMemo(() => {
    return allValues
      .filter((val: any) => val.lookup === "Notification")
      .map((val: any) => ({
        text: AN_TYPES[val.notificationMessageType],
        checked: val.isActive,
        onChange: handleChange(val.lookupid, val.notificationMessageTypeId),
      }));
  }, [allValues]);

  const alertConfiguration = useMemo(() => {
    return allValues
      .filter((val: any) => val.lookup === "Alert")
      .map((val: any) => ({
        text: AN_TYPES[val.notificationMessageType],
        checked: val.isActive,
        onChange: handleChange(val.lookupid, val.notificationMessageTypeId),
      }));
  }, [allValues]);

  useEffect(() => {
    if (userDetails && countryDropdown) {
      countryDropdown?.forEach((x: any) => {
        if (x?.value == userDetails.countryId) {
          setSelectedCountry(x);
          const value = x?.value;
          setForm({ ...form, countryId: value });
        }
      });
    }
  }, [userDetails, countryDropdown]);

  useEffect(() => {
    const externalUser: any = externalUserData || {};
    if (Object.keys(externalUser).length || userDetails?.emailId) {
      let arr = { ...userName };
      arr["firstName"] = !externalUser?.userInternal
        ? externalUser.firstName
        : userDetails.firstName || userDetails?.userName;
      arr["lastName"] = !externalUser?.userInternal
        ? externalUser.lastName
        : userDetails.lastName;
      arr["preferredName"] =
        userDetails.userName || externalUser.firstName;
      arr["userEmail"] = userDetails?.emailId;
      arr["title"] = !externalUser?.userInternal
        ? externalUser.title
        : userDetails.title;
      arr["employeeNumber"] = !externalUser?.userInternal
        ? externalUser.employeeNumber
        : userDetails.employeeNo;
      arr["homeCostCenter"] = !externalUser?.userInternal
        ? externalUser.homeCostCenterNo
        : userDetails.homeCostCenter;
      setUserName(arr);
      const preferredName = userDetails?.userName
        ? userDetails.userName
        : externalUser.firstName;

      let branchIds = userDetails?.branches?.map((x: any) => x?.branchNo);
      setChecked(branchIds);

      setForm((prev: any) => ({
        ...prev,
        ...userDetails,
        branchIds,
        firstName: !externalUser?.userInternal
          ? externalUser.firstName
          : userDetails.firstName,
        lastName: !externalUser?.userInternal
          ? externalUser.lastName
          : userDetails.lastName,
        userName: preferredName,
        emailId: userDetails?.emailId,
        employeeId: !externalUser?.userInternal
          ? String(externalUser.employeeNumber)
          : String(userDetails.employeeNo),
        jobTitle: !externalUser?.userInternal
          ? externalUser.title
          : userDetails.title,
        homeCostCenter: !externalUser?.userInternal
          ? externalUser.homeCostCenterNo
          : userDetails.homeCostCenter,
      }));
    }
  }, [externalUserData, userDetails]);

  const validation: any = (name: any, value: any) => {
    let error = { ...formError };
    switch (name) {
      case "zipCode":
        if (value != null) {
          if (value.length > 10) {
            error.zipCodeError = "ZipCode should be in 10 digits only";
          } else {
            error.zipCodeError = "";
          }
        }
        break;
      case "personalEmailId":
        if (value != null) {
          if (value.length > 50) {
            error.personalEmailId =
              "Email Id should contain only 50 characters";
          } else if (value) {
           
            const isVallidEmail = isEmail(value);
            if (isVallidEmail) {
              error.personalEmailId = "";
            } else {
              error.personalEmailId = "Please Enter Valid Email Id";
            }
          } else {
            error.personalEmailId = "";
          }
        }
        break;
      case "profileImage":
        if (value != null) {
          if (value < 150) {
            error.profileImageError = "Profile image shoule be less than 150kb";
          } else {
            error.profileImageError = "";
          }
        }
        break;
      case "addressLine1":
        if (value != null) {
          if (value?.length > 50) {
            error.addressLine1Error =
              "Address Line1 should contain only 50 characters";
          } else {
            error.addressLine1Error = "";
          }
        }
        break;
      case "addressLine2":
        if (value != null) {
          if (value.length > 50) {
            error.addressLine2Error =
              "Address Line2 should contain only 50 characters";
          } else {
            error.addressLine2Error = "";
          }
        }
        break;
      case "city":
        if (value != null) {
          if (value.length > 25) {
            error.cityError = "City should contain only 25 characters";
          } else {
            error.cityError = "";
          }
        }
        break;
      case "state":
        if (value != null) {
          if (value.length > 25) {
            error.stateError = "State should contain only 25 characters";
          } else {
            error.stateError = "";
          }
        }
        break;
      case "profileImageDimension":
        if (value != null) {
          if (value > 400) {
            error.profileImageError =
              "Profile image's height and width must not exceed 400px.";
          } else {
            error.profileImageError = "";
          }
        }
        break;
      default:
        break;
    }
    return error;
  };

  const isValidateProfile = () => {
    let valid = true;
    let formValError: any = {};
    for (let key in form) {
      let formVal = validation(key, form[key]);
      formValError[key + "Error"] = formVal[key + "Error"];
      if (formVal[key + "Error"]) {
        valid = false;
      }
    }
    setFormError({ ...formValError });
    return valid;
  };

  const onUpdateProfileField = (e: any) => {
    const { name, value } = e.target;
    let errorValue = validation(name, value);
    setFormError({ ...errorValue });
    setForm({ ...form, [name]: value });
    if (e.target.name == "zipCode" || e.target.name == "contactNo") {
      const result = e.target.value.replace(/\D/g, "");

      setForm({ ...form, [name]: result });
    }
  };

  const hideDialogAndUserProfile = () => {
    setIsConfirmationDialogVisible(false);
    closeModalPopup();
    dispatch(setResultMessage(""));
    dispatchGetUserDetails({user: userDetails?.emailId})
  };

  const [isConfirmationDialogVisible, setIsConfirmationDialogVisible] =
    useState(false);
  const hideConfirmationDialog = useCallback(
    () => setIsConfirmationDialogVisible(false),
    []
  );

  const confirmationDialogContentProps = {
    subText: (
      <>
        <div className="dialog-msg mb-3">{resultMessage}</div>
        <div className="dialog-btn-header text-center">
          <PrimaryButton
            text="Ok"
            onClick={hideDialogAndUserProfile}
            className="successdialog-btn"
           data-attribute="UserProfile_container_Default_Button" />
        </div>
      </>
    ),
  };

  const saveUserPersonalInfo = () => {
    let isValid = isValidateProfile()
    if (isValid) {
      setIsConfirmationDialogVisible(true);
      const payload = {
        userId: form?.userId,
        firstName: form?.firstName ?? "",
        lastName: form?.lastName ?? "",
        userName: form?.userName ?? "",
        emailId: form?.emailId ?? "",
        employeeId: form?.employeeId ?? "",
        jobTitle: form?.jobTitle ?? "",
        fax: form?.fax ?? "",
        contactNo: form?.contactNo ?? "",
        personalEmailId: form?.personalEmailId ?? "",
        homeCostCenter: form?.homeCostCenter ?? "",
        profileBlobUrl: form?.profileBlobUrl ?? "",
        addressLine1: form?.addressLine1 ?? "",
        addressLine2: form?.addressLine2 ?? "",
        city: form?.city ?? "",
        state: form?.state ?? "",
        zipCode: form?.zipCode ?? "",
        countryId: form.countryId ? +form.countryId : null,
        savedBy: userDetails?.emailId,
        applicationName: CONSTANTS?.ORDER_MANAGEMENT
      }
      dispatch(saveUserProfilePersonalInfo(payload));
      setFormError(initialError);
    }
  }

  const saveUserBranches = () => {
    if (
      form?.branchIds?.length === 0 ||
      form?.branchIds?.length === undefined
    ) {
      setFormError((prev: any) => ({ ...prev, branchError: "At least one branch is required" }));
    } else if(defaultBranchDetails?.branchId && form?.branchIds?.filter((item?: any) =>  item?.toString() == defaultBranchDetails?.branchId?.toString())?.length == 0){
      let decriptionTxt = (
        <>
          <p>The location{' (' + defaultBranchDetails?.branchNumber + ' - ' + defaultBranchDetails?.companyName + ') '}is set as your default location. You must change the default location before removing the location.</p>
        </>
      );

      setPopupcontent({
        ...Popupcontent,
        titleImg: ConfirmationBee,
        title: "INFORMATION",
        isDialogVisible: true,
        isTitleWarning: false,
        subtextcontent: decriptionTxt,
        outlineBtnText: "Ok",
        isSingleConfirmationBtn: true,
        popupOutlinebtnOnclick: () => {
          setPopupcontent({ ...Popupcontent, isDialogVisible: false })
        }
      });
    } else {
      setIsConfirmationDialogVisible(true);
      setFormError((prev: any) => ({ ...prev, branchError: "" }));
      const payload = {
        emailId: form?.emailId,
        branchIds: form?.branchIds,
        savedBy: userDetails?.emailId,
        applicationName: CONSTANTS.ORDER_MANAGEMENT
      }
      dispatch(saveUserProfileBranches(payload))
      setFormError(initialError);
    }
  }

  const saveUserNotificationSubs = () => {
    setIsConfirmationDialogVisible(true);
    dispatch(saveUserProfileNotificationSubs(allValues))
  }

  const onSubmitForm = () => {
    if(selectedTab === "Personal Info"){
      saveUserPersonalInfo()
    } else if(selectedTab === "Alerts"){
      saveUserNotificationSubs()
    } else if(selectedTab === "Locations"){
      saveUserBranches()
    } else {
      return
    }
  }


  const updateSubCategoryAndCostCenterCount = (treeNode: any) => {
    if (treeNode.children === null) {
      return []
    };

    const subCategories: any = [];
    const costCenter: any = [];

    treeNode?.children?.forEach((acc: any) => {
        if (acc.entityType === 'CostCenter') {
          costCenter.push(acc?.entityId);
        } else {
            subCategories.push(acc);
        }
    });

    treeNode.subcategoryCount = subCategories?.length;
    treeNode.costCenterCount = [...costCenter, ...
        subCategories.reduce((acc: any, subCategory: any) => {
            return [...acc, ...updateSubCategoryAndCostCenterCount(subCategory)];
        }, [])];
    return treeNode.costCenterCount;
};

  const getTooltipText = (id: any, name: any, branch?: any) => {
    if (name !==  "CostCenter") {
      if (branch?.children?.length) {
        if(name === "Division"){
          return "Click the checkbox to select all locations in the Division or click the plus sign to expand to choose locations"
        }
        const ids = updateSubCategoryAndCostCenterCount(branch);
        let count = 0;
        ids?.forEach((i: any, index: any) => {
          let val = (strcount == 0) ? Number(i) : i + ""

          if (Item.current?.includes(val)) {
            ++count;
          }
        })
        if (count === ids?.length) {
          return "unselect all"
        }
        if (count > 0) {
          return `${count} Cost Center selected`
        }
        if (count === 0) {
          return `select all ${ids?.length} Cost Center`
        }
      }
      return "select all"
    } else {
      let val = (strcount == 0) ? Number(id) : id + ""
      return Item.current?.includes(val) ? "unselect" : "select";
    }
  }

  
  const getEntityLabel = (company: any) => {
    if(company?.entityCode){
      return `${company?.entityType === 'SuperRegion' ? 'Super Region' : company?.entityType} : ${company?.entityCode} - ${company?.entityName}`
    } else {
      return `${company?.entityType === 'SuperRegion' ? 'Super Region' : company?.entityType} : ${company?.entityName}`
    }
  }

  let branchesOptions :any = []
  const createTree = (data: any) => {
    const treeData = data?.length ? data?.map((company: any) => {
      if (company?.entityType === 'CostCenter') {
        branchesOptions.push({
          label: `${company?.entityCode} - ${company?.entityName}`,
          value: company?.entityCode,
          key: company?.entityCode
        })
        return {
          label: `Cost Center : ${company?.entityCode} - ${company?.entityName}`,
          value: company?.entityId,
          title: getTooltipText(company?.entityId, company?.entityType),
        }
      }
      count++
      return {
        label: getEntityLabel(company),
        value: `${company?.entityType} : ${company?.entityName} - ${company?.entityId} - ${count}`,
        title: getTooltipText(company?.companyId, company?.entityType, company),
        children: createTree(company?.children)
      }
    }) : []
    setCostCenterOptions([...branchesOptions])
    return treeData
  }

  const branches = useMemo(() => {
    if (Array.isArray(getBranchValues)) {
      return [
        {
          label: "Locations",
          value: "Locations",
          children: createTree(getBranchValues),
          title: "Click the checkbox to select all locations  or click the plus sign to expand to choose locations",
        },
      ];
    } else {
      return [];
    }
  }, [getBranchValues]);

  const onClick = () => {
    closeModalPopup();
    dispatch(setResultMessage(""));
  };
  const { getResultMessage } = useSelector((state: any) => ({
    getResultMessage: state.UserProfile.resultMessage,
  }));

  const onSearchInputChange = (data: any, searchedNodes: any) => {
    if(filteredCostCenter?.value?.trim() && !data.value.trim()){
      setFilteredCostCenter(data);
      setExpanded(['Locations'])
    } else {
      setFilteredCostCenter(data);
      setExpanded(getAllValuesFromNodes(searchedNodes, true))
    }
  };
  
  const getHighlightText = (text: any, keyword: any) => {
    const startIndex = text.indexOf(keyword);
    return startIndex !== -1 ? (
      <span>
        {text.substring(0, startIndex)}
        <span style={{ color: '#2cb664' }}>
          {text.substring(startIndex, startIndex + keyword.length)}
        </span>
        {text.substring(startIndex + keyword.length)}
      </span>
    ) : (
      <span>{text}</span>
    );
  };
  
  const keywordFilter = (nodes: any, keyword: any) => {
    let newNodes = [];
    if(keyword?.length){
      for (let n of nodes) {
        if (n.children) {
          const nextNodes = keywordFilter(n.children, keyword);
          if (nextNodes.length > 0) {
            n.children = nextNodes;
          } else if (n.label.toLowerCase().includes(keyword?.toLowerCase())) {
            n.children = nextNodes.length > 0 ? nextNodes : [];
          }
          if (
            nextNodes.length > 0 ||
            n.label.toLowerCase().includes(keyword?.toLowerCase())
          ) {
            n.label = getHighlightText(n.label, keyword);
            newNodes.push(n);
          }
        } else {
          if (n.label.toLowerCase().includes(keyword?.toLowerCase())) {
            n.label = getHighlightText(n.label, keyword);
            newNodes.push(n);
          }
        }
      }
    }
    return newNodes;
  };
  
  const getAllValuesFromNodes = (nodes: any, firstLevel: any): any => {
    const values = [];
    for (let n of nodes) {
      values.push(n.value);
      if (n.children) {
        values.push(...getAllValuesFromNodes(n.children, false));
      }
    }
    return values;
  };
  
  let searchedNodes = filteredCostCenter?.label?.trim()
  ? keywordFilter(_.cloneDeep(branches), filteredCostCenter?.label)
  : branches;  
 
  const onClickCostCenterReset = () => {
    setExpanded(['Locations'])
    setFilteredCostCenter('')
  }

const branchTabContent = () => {
    return (<>
      <div className="search-clear-block mt-3">
        <ReactSelectBox
            options={costCenterOptions}
            onChange={(data: any) => onSearchInputChange(data, searchedNodes)}
            value={filteredCostCenter || '' }
            isSearchable={true}
            placeholder='Search Cost Center'
            className='mb-3'
           data-attribute="UserProfile_container_Default_SearchSelectBox" />
          <EventHandler onEvent={() => onClickCostCenterReset()} data-attribute="UserProfile_container_Default_EventHandler">
            <span className="reset-icon-search">
                <img src={resetIcon} alt='Reset'/>
            </span>
          </EventHandler>
      </div>
      <div className="errorMsg mb-2">{formError.branchError}</div>
      <div className="location-tab-ui">
        <CustomTreeview
          nodes={searchedNodes}
          checked={Item.current}
          onCheck={OnCheckboxClick}
          showNodeIcon={false}
          expandNode={expanded}
          noCascade={!!filteredCostCenter}
         data-attribute="UserProfile_container_Default_CustomTreeview" />
      </div>
    </>);
  };
  const profileImage = () => {
    if (uploadedImage) {
      return uploadedImage;
    } else {
      if (form.profileBlobUrl) {
        return form.profileBlobUrl;
      }
        return uploadimg;
    }
  };
  useEffect(() => {
    if (isOutOfOfficeSavedProfile) {
      let decriptionTxt = (
        <>
          <p>Saved Successfully.</p>
        </>
      );

      setPopupcontent({
        ...Popupcontent,
        titleImg: SuccessBee,
        title: "Information",
        isDialogVisible: true,
        isTitleWarning: false,
        subtextcontent: decriptionTxt,
        outlineBtnText: "Ok",
        isSingleConfirmationBtn: true,
        popupOutlinebtnOnclick: () => {
          dispatch(setIsOutOfOfficeSavedProfile(undefined))
          dispatch(setCurrentSettingsProfile({}))
          hideDialogAndUserProfile()
          setPopupcontent({ ...Popupcontent, isDialogVisible: false })
        }
      });
    }
  }, [isOutOfOfficeSavedProfile])



  const hideApprovalConfirmationDialog = useCallback(
    () => setPopupcontent({ ...Popupcontent, isDialogVisible: false }),
    [Popupcontent]
  );

  const handleLinkClick = (item?: PivotItem) => {
    if (item) {
      setSelectedTab(item.props.headerText);
      setFormError(initialError)
    }
  };

  return (
    <>
      <UserProfile
        userName={userName}
        countryDropdown={countryDropdown}
        form={form}
        formError={formError}
        onUpdateProfileField={onUpdateProfileField}
        onSubmitForm={onSubmitForm}
        BranchDetails={getBranchValues}
        selectedCountry={selectedCountry}
        onChangeCountry={onChangeCountry}
        OnCheckboxClick={OnCheckboxClick}
        checkedValue={checkedValue}
        onChangeProfile={onChangeProfile}
        closeModalPopup={closeModalPopup}
        isConfirmationDialogVisible={isConfirmationDialogVisible}
        hideConfirmationDialog={hideConfirmationDialog}
        confirmationDialogContentProps={confirmationDialogContentProps}
        userprofileinfo={userprofileinfo}
        uploadedImage={uploadedImage}
        userDetails={userDetails}
        alertConfiguration={alertConfiguration}
        notificationConfiguration={notificationConfiguration}
        branchTabContent={branchTabContent}
        profileImage={profileImage}
        onClick={onClick}
        getResultMessage={getResultMessage}
        errorMessage={errorMessage}
        selectedTab={selectedTab}
        handleLinkClick={handleLinkClick}
        hideApprovalConfirmationDialog={hideApprovalConfirmationDialog}
        Popupcontent={Popupcontent}
      />
    </>
  );
};

export default UserProfileContainer;
